import { render, staticRenderFns } from "./CheckUsernamePage.vue?vue&type=template&id=28ef985c"
import script from "./CheckUsernamePage.vue?vue&type=script&lang=js"
export * from "./CheckUsernamePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports